export const LOGIN = `/auth/token`;
export const OTP_SIGNUP = `/auth/send-login-or-signup-otp`;
export const OTP_LOGIN = `/auth/verify-login-or-signup-otp`;
export const THIRD_PARTY_LOGIN = `/auth/third-party-login-signup`;
export const SIGN_UP = `/profile/`
export const UPDATE_PASSWORD_OTP = `/auth/update-password-otp`
export const FORGOT_PASSWORD_OTP = `/auth/forget-password-otp`
export const RESEND_OTP = `/auth/resend-login-or-signup-otp`